<template>
  <div>
    <b-container fluid>    
      <b-container style="padding-bottom: 64px; padding-top: 64px">
        <b-row align-h="center" align-v="center">
          <b-col cols="12" md="8">
            <h1 class="text-center" style="padding-bottom: 32px">Rim Normal</h1>

            <h4>O que veremos nesse módulo:</h4>
            <!-- <ul class="list">
              <li v-for="item in conteudo" :key="item.id">{{item.description}}</li>
            </ul> -->

            <p class="text-justify">
              A importância em apresentar aspectos histológicos do Rim Normal está no fato de preparar a
              tela em que as alterações patológicas irão se desenvolver. Veremos aspectos relacionados à
              anatomia, histologia do Rim Normal, e nos habituando às colorações mais utilizadas.
            </p>

            <div class="text-center">
              <router-link to="/rim-normal/revisao" class="btn btn-primary">INICIE SEUS ESTUDOS</router-link>
              &nbsp;  
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

  </div>
</template>

<script>
export default {
  name: "Menu",
};
</script>

<style scoped>
ul li {
  list-style-type: square;
  list-style-position: inside;
}

</style>